/* script */
//
//
//
//
//
//


/**
 * This components presents a button to open the creation wizard.
 * It can be fed with wizard initial data through the prop: `params`.
 *
 * @vue-prop {Object} param the wizard initial data
 * @vue-prop {Object} user the current user object
 *
 * @category ui.components
 * @exports CreateTemplateButton
 */
import CreateTemplate from 'ui/components/wizards/CreateTemplate.vue';

const __vue_script__ = {
    name: 'CreateTemplateButton',

    props: {
        user: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            routeParams: null
        };
    },

    created() {
        // This is a violation of routes blackboxing
        // therefore soon or later we'll have to refactor this
        this.routeParams = this.$router.getSearchParams();

        if (this.routeParams.create) {
            this.startWizard();
        }
    },

    methods: {
        startWizard() {
            this.$modal.show(CreateTemplate,
                this.params,
                {
                    classes: 'small',
                    height: 'auto',
                    reset: true,
                    clickToClose: false
                },
                {
                    'before-close': () => this.cleanRoute()
                }
            );

            this.setRouteParams();
        },

        /**
         * Removes component's specific parameters from the route
         */
        cleanRoute() {
            delete this.routeParams.create;
            delete this.routeParams.eid;

            this.$router.setSearchParams(this.routeParams);
        },

        /**
         * Sets component's specific parmaeters to the route
         */
        setRouteParams() {
            this.routeParams.create = true;
            this.$router.setSearchParams(this.routeParams);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-template-button" }, [
    _c(
      "button",
      { staticClass: "btn btn-primary", on: { click: _vm.startWizard } },
      [_vm._v(_vm._s(_vm.$t("templates.create_template")))]
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/CreateTemplateButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__